import { render, staticRenderFns } from "./WiFiModal.vue?vue&type=template&id=2ba840cc&scoped=true&"
import script from "./WiFiModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WiFiModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./WiFiModal.vue?vue&type=style&index=0&id=2ba840cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba840cc",
  null
  
)

export default component.exports